import { logDebug, mainLogger } from '../logger';
import { SharingActionType, sharingVendorsConfig } from '../types';
export const serializeObject = (object, propertySeparator, keyValueSeparator) => Object.entries(object).reduce((acc, [key, value]) => `${acc}${acc.length ? propertySeparator : ''}${key}${keyValueSeparator}${value}`, '');

// good info on popup windows https://javascript.info/popup-windows
export const sharingWindowName = 'shareWindow';
export const openShareDialog = url => {
  const {
    availWidth: w,
    availHeight: h
  } = window.screen;
  const heightPercent = 60;
  const widthPercent = 70;
  const popupSettings = {
    height: Math.round(heightPercent * h * 0.01),
    left: Math.round((100 - widthPercent) * 0.5 * w * 0.01),
    top: Math.round((100 - heightPercent) * 0.5 * h * 0.01),
    width: Math.round(widthPercent * w * 0.01)
  };
  const options = serializeObject(popupSettings, ',', '=');
  logDebug(`Opening sharing dialog with URL ${url} ...`);
  return window.open(url, sharingWindowName, options);
};
export const openSharingWindowError = 'Error while opening sharing window popup:';
export const sharingWindowNotSetError = `Sharing window wasn't set up properly.`;
export const vendorGetSharingLinkError = vendor => `Routine for creating final shared link is not set up for ${vendor}.`;
export const share = async ({
  onCopyLink,
  onError,
  sharedContent,
  vendor
}) => {
  const errorCallback = (context, error) => {
    mainLogger.error(error, {
      action: 'Share error callback',
      context
    });
    onError?.(context, error);
  };
  const config = sharingVendorsConfig[vendor];
  const {
    actionType = SharingActionType.NewWindow,
    getSharingLink
  } = config;
  if (!getSharingLink) {
    errorCallback(vendorGetSharingLinkError(vendor));
    return;
  }

  // sharing window opened already here if it will be needed
  // so that the popup isn't blocked in most browsers
  // (opening in user-triggered action no later than during
  // 2 seconds is usually required for the popup to not be blocked)
  let sharingWindow;
  if (actionType === SharingActionType.NewWindow) {
    try {
      sharingWindow = openShareDialog('about:blank') ?? undefined;
      if (sharingWindow) {
        const html = `<div style="font-family: sans-serif; font-size:14px">Loading ...</div>`;
        sharingWindow.document.body.insertAdjacentHTML('afterbegin', html);
      }
    } catch (error) {
      errorCallback(openSharingWindowError, error);
      return;
    }
  }
  let data;
  if (typeof sharedContent === 'function') {
    data = await sharedContent();
  } else {
    data = sharedContent;
  }
  logDebug('Shared content:', data);

  // compose final link
  const finalSharedLink = getSharingLink(data);
  logDebug('Final shared link:', finalSharedLink);

  // share the contents
  switch (actionType) {
    case SharingActionType.DirectNavigation:
      logDebug(`Navigating directly to ${finalSharedLink} ...`);
      window.location.href = finalSharedLink;
      break;
    case SharingActionType.CopyLinkDialog:
      logDebug(`Opening copy link popup for ${finalSharedLink} ...`);
      // The implementation is injected via the onCopyLink callback
      // to have it better separated (will probably involve a separate UI).
      onCopyLink?.(vendor, finalSharedLink);
      break;
    default:
      if (sharingWindow) {
        logDebug(`Setting sharing window URL to ${finalSharedLink} ...`);
        sharingWindow.location.href = finalSharedLink;
        sharingWindow.opener = null; // security reasons & we lost access to it
      } else {
        errorCallback(sharingWindowNotSetError);
      }
  }

  // TO-DO: solve share process result in future?
};
//# sourceMappingURL=share.js.map